/* Status badge component using .badge-* CSS classes from index.css.
   Supports both status-based rendering (ContractStatus) and direct variant prop. */
import { clsx } from 'clsx';
import type { ContractStatus } from '../../types';

type BadgeVariant =
  | 'draft'
  | 'active'
  | 'pending'
  | 'expired'
  | 'completed'
  | 'archived'
  | 'expiredHistorical';

interface StatusBadgeProps {
  status: ContractStatus;
  variant?: never;
  label?: never;
  className?: string;
}

interface VariantBadgeProps {
  variant: BadgeVariant;
  label: string;
  status?: never;
  className?: string;
}

type BadgeProps = StatusBadgeProps | VariantBadgeProps;

const statusToVariant: Record<ContractStatus, BadgeVariant> = {
  draft: 'draft',
  generated: 'completed',
  archived: 'archived',
};

const statusLabels: Record<ContractStatus, string> = {
  draft: 'Draft',
  generated: 'Generated',
  archived: 'Archived',
};

export default function Badge(props: BadgeProps) {
  if (props.variant !== undefined) {
    return (
      <span className={clsx(`badge-${props.variant}`, props.className)}>
        {props.label}
      </span>
    );
  }

  return (
    <span
      className={clsx(`badge-${statusToVariant[props.status]}`, props.className)}
    >
      {statusLabels[props.status]}
    </span>
  );
}
